<kendo-dialog title="Aligning Tier" (close)="onCancel()">
  <div class="align-tier-confirmation-message">
    <p>
      This action will align all restaurants moved to tier
      <strong> {{ tierToAlign.name }}</strong> to king restaurant
      <strong>{{ tierToAlign.kingRestaurantName }}</strong
      >.
    </p>
    <p>
      Only items with prices that differ from the king restaurant will be
      updated.
    </p>
    <p>
      Changes will be saved and will be available for syncing at your
      convenience.
    </p>
    <p>Are you sure you want to proceed?</p>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="onCancel()">No</button>
    <button kendoButton (click)="onProceed()" themeColor="primary">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
